<template>
  <div class="form-group">
    <label class="col-xs-3" :for="name">{{ label }}:</label>
    <div class="col-xs-9">
      <textarea class="form-control"
                :id="name"
                :placeholder="placeholder"
                :name="name"
                @input="updateValue($event.target.value)"
                :value="value"></textarea>
      <span class="text-danger" v-if="error" v-text="error"></span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      name: { required: true },
      label: { required: false },
      value: { required: false },
      error: { required: false },
      placeholder: { required: false },
    },
    data() {
      return {}
    },
    methods: {
      updateValue(value) {
        this.$emit('input', value);
      }
    },
    mounted() {}
  }
</script>


// WEBPACK FOOTER //
// resources/js/components/Textarea.vue